import request from '@/utils/request'
export function query(params) {
  return request({
    url:'/video/query',
    method:'post',
    data:params
  })
}
export function update(params) {
  return request({
    url:'/video/update',
    method:'post',
    data:params
  })
}
export function deleteVideo(params) {
  return request({
    url:'/video/delete/' + params,
    method:'post'
  })
}
export function create(data) {
  return request({
    url:'/video/create',
    method:'post',
    data:data
  })
}

//置顶
export function getDetail(params) {
  return request({
    url:'/video/detail/' + params,
    method:'get'
  })
}

